// DataQueryHelper.ts 
export interface DataQuerySetup
{
    isUsed: boolean, 
    componentID: string
}

export function setDataQueryComponentId() : DataQuerySetup {
    let params = new URLSearchParams(document.location.search);
    if (params.has("DQC")) {
        return {isUsed: true, componentID: params.get("DQC") ?? ""};
    }
    return {isUsed: false, componentID: ""}
}